import {
    addContract,
    getAllContracts,
    getContract,
    getContractUsers,
    editContract,
    addContractStatus,
    updateContractStatus,
    deleteContractStatus,
    getContractStatus,
    getAllContractStatus,
    getAllContractStatusList,
    getAllContractLostReason,
    getAllContractLostReasonList,
    getContractLostReason,
    addContractLostReason,
    updateContractLostReason,
    deleteContractLostReason,
    getContractParameters,
    editContractParameters,
    getContractParametersList,
} from "../../config/config";
import { toast } from "react-toastify";
export const API_REQUEST = "API_REQUEST";

export const SET_CONTRACT_FILTERS = "SET_CONTRACT_FILTERS";

export const ADD_CONTRACT_STATUS_SUCCESS = "ADD_CONTRACT_STATUS_SUCCESS";
export const GET_ALL_CONTRACT_STATUS_SUCCESS = "GET_ALL_CONTRACT_STATUS_SUCCESS";
export const GET_CONTRACT_STATUS_SUCCESS = "GET_CONTRACT_STATUS_SUCCESS";
export const UPDATE_CONTRACT_STATUS_SUCCESS = "UPDATE_CONTRACT_STATUS_SUCCESS";
export const DELETE_CONTRACT_STATUS_SUCCESS = "DELETE_CONTRACT_STATUS_SUCCESS";

export const ADD_CONTRACT_STATUS = "ADD_CONTRACT_STATUS";
export const GET_ALL_CONTRACT_STATUS = "GET_ALL_CONTRACT_STATUS";
export const GET_CONTRACT_STATUS = "GET_CONTRACT_STATUS";
export const UPDATE_CONTRACT_STATUS = "UPDATE_CONTRACT_STATUS";
export const DELETE_CONTRACT_STATUS = "DELETE_CONTRACT_STATUS";

export const ADD_CONTRACT_PRODUCT_TO_CART = "ADD_CONTRACT_PRODUCT_TO_CART";
export const DELETE_CONTRACT_PRODUCT_FROM_CART = "DELETE_CONTRACT_PRODUCT_FROM_CART"
export const EMPTY_CONTRACT_PRODUCT_CART = "EMPTY_CONTRACT_PRODUCT_CART"
export const CHANGE_CONTRACT_PAGE = "CHANGE_CONTRACT_PAGE"
export const SET_VIEW = "SET_VIEW"
export const ADD_CONTRACT_DISC = "ADD_CONTRACT_DISC"
export const GET_ALL_CONTRACTS = "GET_ALL_CONTRACTS"
export const GET_CONTRACT_SUCCESS = "GET_CONTRACT_SUCCESS"
export const GET_CONTRACT_USERS = "GET_CONTRACT_USERS"
export const GET_CONTRACT = "GET_CONTRACT"
export const ADD_CONTRACT_SUCCESS = "ADD_CONTRACT_SUCCESS"
export const ADD_CONTRACT = "ADD_CONTRACT"
export const EDIT_CONTRACT_SUCCESS = "EDIT_CONTRACT_SUCCESS"
export const EDIT_CONTRACT = "EDIT_CONTRACT"
export const STORE_CONTRACT = "STORE_CONTRACT"
export const EMPTY_CONTRACT = "EMPTY_CONTRACT"
export const STORE_CONTRACT_PRODUCTS = "STORE_CONTRACT_PRODUCTS"
export const DELETE_CONTRACT_SUCCESS = "DELETE_CONTRACT_SUCCESS"
export const DELETE_CONTRACT = "DELETE_CONTRACT"
export const CALCULATE_CONTRACT_TAX = "CALCULATE_CONTRACT_TAX"
export const CHANGE_CONTRACT_PRODUCT_LOADER = "CHANGE_CONTRACT_PRODUCT_LOADER"

export const SET_CONTRACT_SELECTED_REASON = "SET_CONTRACT_SELECTED_REASON"

export const GET_ALL_CONTRACTS_FILTER_SUCCESS = "GET_ALL_CONTRACTS_FILTER_SUCCESS"
export const GET_ALL_CONTRACTS_FILTER = "GET_ALL_CONTRACTS_FILTER"

export const GET_ALL_CONTRACT_STATUS_LIST = "GET_ALL_CONTRACT_STATUS_LIST";

export const GET_ALL_CONTRACT_LOST_REASON_LIST = "GET_ALL_CONTRACT_LOST_REASON_LIST";
export const ADD_CONTRACT_LOST_REASON_SUCCESS = "ADD_CONTRACT_LOST_REASON_SUCCESS";
export const GET_ALL_CONTRACT_LOST_REASON_SUCCESS = "GET_ALL_CONTRACT_LOST_REASON_SUCCESS";
export const GET_CONTRACT_LOST_REASON_SUCCESS = "GET_CONTRACT_LOST_REASON_SUCCESS";
export const UPDATE_CONTRACT_LOST_REASON_SUCCESS = "UPDATE_CONTRACT_LOST_REASON_SUCCESS";
export const DELETE_CONTRACT_LOST_REASON_SUCCESS = "DELETE_CONTRACT_LOST_REASON_SUCCESS";

export const ADD_CONTRACT_LOST_REASON = "ADD_CONTRACT_LOST_REASON";
export const GET_ALL_CONTRACT_LOST_REASON = "GET_ALL_CONTRACT_LOST_REASON";
export const GET_CONTRACT_LOST_REASON = "GET_CONTRACT_LOST_REASON";
export const UPDATE_CONTRACT_LOST_REASON = "UPDATE_CONTRACT_LOST_REASON";
export const DELETE_CONTRACT_LOST_REASON = "DELETE_CONTRACT_LOST_REASON";

export const GET_CONTRACT_PARAMETERS = "GET_CONTRACT_PARAMETERS";
export const GET_CONTRACT_PARAMETERS_LIST = "GET_CONTRACT_PARAMETERS_LIST";
export const EDIT_CONTRACT_PARAMETERS = "EDIT_CONTRACT_PARAMETERS";

export const GET_CONTRACT_PARAMETERS_SUCCESS = "GET_CONTRACT_PARAMETERS_SUCCESS";
export const EDIT_CONTRACT_PARAMETERS_SUCCESS = "EDIT_CONTRACT_PARAMETERS_SUCCESS";
//GET CONTRACT
const getContracts = (page, limit, status, filters, loading, setPage, setFailedPage, view, dispatch) => {
    if (loading)
        dispatch({
            type: GET_ALL_CONTRACTS_FILTER,
            payload: {
                getContractsFilterLoading: true
            },
        });
    else
        dispatch({
            type: GET_ALL_CONTRACTS,
            payload: {
                getContractsLoading: true
            },
        });
    getAllContracts(page, limit, status, filters).then((res) => {

        if (loading)
            dispatch({
                type: GET_ALL_CONTRACTS_FILTER,
                payload: {
                    getContractsFilterLoading: false
                },
            });
        else
            dispatch({
                type: GET_ALL_CONTRACTS,
                payload: {
                    getContractsLoading: false
                },
            });
        if (res?.status === 200) {

            if (typeof setPage === 'function' && view) {
                setPage(page + 1);
            }
            if (typeof setPage === 'function' && !view) {
                setPage();
            }
            dispatch({
                type: "SET_PAGE_DETAILS",
                payload: {
                    page: "contracts",
                    currentPage: res?.data?.currentPage,
                    totalPages: res?.data?.totalPages,
                    totalRecords: res?.data?.totalRecords
                },
            });
            dispatch({
                type: GET_ALL_CONTRACTS_FILTER_SUCCESS,
                payload: {
                    contracts: res?.data?.contracts,
                    page: res?.data?.currentPage,
                    totalPages: res?.data?.totalPages,
                    totalRecords: res?.data?.totalRecords,
                    view,
                    max: res?.data?.maxNetValue,
                    min: res?.data?.minNetValue,
                    sum: res?.data?.totalSumValue
                },
            });
        } else if (res?.status === 401) {
            window.location = "/session-ended";
        } else if (res?.status === 403) {
            window.location = "/forbidden";
        } else {
            toast.error(res?.data?.message || "error", { theme: "colored" });
        }
    }).catch(() => {
        if (typeof setFailedPage === 'function') {
            setFailedPage(page)
        }
    });


}

const actions = {

    setView: (data) => (dispatch) => {
        dispatch({ type: SET_VIEW, payload: { view: data } })
    },
    setSelectedReason: (data) => (dispatch) => {
        dispatch({ type: SET_CONTRACT_SELECTED_REASON, payload: { selectedReason: data } })
    },
    //ADD PRODUCT TO CART
    addProductToCart: (data) => (dispatch) => {

        dispatch({ type: ADD_CONTRACT_PRODUCT_TO_CART, payload: { product: data } })
    },


    changeProductLoader: (data) => (dispatch) => {

        dispatch({ type: CHANGE_CONTRACT_PRODUCT_LOADER, payload: { productLoader: data } })
    },



    changePage: (data, flag = false) => (dispatch) => {

        dispatch({ type: CHANGE_CONTRACT_PAGE, payload: { page: data, flag: flag } })
    },


    //DELETE PRODUCT FORM CART
    deleteProductFromCart: (data) => (dispatch) => {

        dispatch({ type: DELETE_CONTRACT_PRODUCT_FROM_CART, payload: { id: data } })
    },

    //EMPTY PRODUCT CART
    emptyProductCart: () => (dispatch) => {

        dispatch({ type: EMPTY_CONTRACT_PRODUCT_CART })
    },
    calculateTax: (data) => (dispatch) => {

        dispatch({ type: CALCULATE_CONTRACT_TAX, payload: { data: data } })
    },
    addInvoiceDisc: (data) => (dispatch) => {

        dispatch({ type: ADD_CONTRACT_DISC, payload: { invoiceDisc: data } })
    },
    //STORE CONTRACT
    storeContract: (data) => (dispatch) => {

        dispatch({ type: STORE_CONTRACT, payload: { data: data } })
    },
    //EMPTY CONTRACT
    emptyContract: (data) => (dispatch) => {

        dispatch({ type: EMPTY_CONTRACT })
    },
    //STORE PRODUCTS
    storeProducts: (data) => (dispatch) => {

        dispatch({ type: STORE_CONTRACT_PRODUCTS, payload: { data: data } })
    },

    //GET CONTRACT
    getContract: (id) => (dispatch) => {
        dispatch({
            type: GET_CONTRACT,
            payload: {
                getContractLoading: true,
            },
        });

        getContract(id).then((res) => {
            dispatch({
                type: GET_CONTRACT,
                payload: {
                    getContractLoading: false,
                },
            });
            if (res?.status === 200) {
                dispatch({
                    type: GET_CONTRACT_SUCCESS,
                    payload: {
                        contract: res?.data?.contract,
                    },
                });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //GET CONTRACT USERS
    getContractUsers: () => (dispatch) => {


        getContractUsers().then((res) => {

            if (res?.status === 200) {
                dispatch({
                    type: GET_CONTRACT_USERS,
                    payload: {
                        salesmen: res?.data?.salesmen,
                        users: res?.data?.users
                    },
                });
            }
            else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },



    //FETCH ALL CONTRACTS
    getAllContracts: (page, limit, status, filters, loading, setPage, setFailedPage = null, view) => (dispatch) => {

        getContracts(page, limit, status, filters, loading, setPage, setFailedPage, view, dispatch)
    },

    //ADD CONTRACT
    addContract: (data, history, push = true, setEdit) => (dispatch) => {
        dispatch({
            type: ADD_CONTRACT,
            payload: {
                addContractLoading: true,
            },
        });


        addContract(data).then((res) => {
            dispatch({
                type: ADD_CONTRACT,
                payload: {
                    addContractLoading: false,
                },
            });

            if (res?.status === 200) {
                dispatch({
                    type: ADD_CONTRACT_SUCCESS,
                    payload: {
                        contracts: res?.data?.contracts,

                    },
                });


                toast.success(res?.data?.message || "Success", { theme: "colored" });
                if (!push && typeof setEdit == 'function')
                    setEdit(res?.data?.addedContract?.uuid)
                else if (push)
                    history.push(`edit-contract/${res?.data?.addedContract?.uuid}`)

            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        })
    },
    //EDIT CONTRACT
    editContract: (data, id, history) => (dispatch) => {
        dispatch({
            type: EDIT_CONTRACT,
            payload: {
                editContractLoading: true,
            },
        });

        editContract(data, id).then((res) => {
            dispatch({
                type: EDIT_CONTRACT,
                payload: {
                    editContractLoading: false,
                },
            });

            if (res?.status === 200) {
                dispatch({
                    type: EDIT_CONTRACT_SUCCESS,
                    payload: {
                        editedContract: res?.data?.editedContract
                    },
                });

                toast.success(res?.data?.message || "Success", { theme: "colored" });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },
    //ADD CONTRACT STATUS
    addContractStatus: (data) => (dispatch) => {
        dispatch({
            type: ADD_CONTRACT_STATUS,
            payload: {
                addContractStatusLoading: true,
            },
        });

        addContractStatus(data).then((res) => {
            dispatch({
                type: ADD_CONTRACT_STATUS,
                payload: {
                    addContractStatusLoading: false,
                },
            });

            if (res?.status === 200) {
                toast.success(res?.data?.message || "Success", { theme: "colored" });
                dispatch({
                    type: ADD_CONTRACT_STATUS_SUCCESS,
                    payload: {
                        contractStatus: res?.data?.statuses,
                        addedStatus: res?.data?.addedStatus
                    },
                });
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //FETCH ALL CONTRACT STATUS
    getAllContractStatus: () => (dispatch) => {
        dispatch({
            type: GET_ALL_CONTRACT_STATUS,
            payload: {
                getContractStatusesLoading: true,
            },
        });
        getAllContractStatus().then((res) => {
            dispatch({
                type: GET_ALL_CONTRACT_STATUS,
                payload: {
                    getContractStatusesLoading: false,
                },
            });
            if (res?.status === 200) {
                dispatch({
                    type: GET_ALL_CONTRACT_STATUS_SUCCESS,
                    payload: {
                        contractStatus: res?.data?.statuses,
                    },
                });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //FETCH ALL CONTRACT STATUS LIST
    getAllContractStatusList: () => (dispatch) => {
        getAllContractStatusList().then((res) => {
            if (res?.status === 200) {
                dispatch({
                    type: GET_ALL_CONTRACT_STATUS_LIST,
                    payload: {
                        contractStatusList: res?.data?.statuses,
                    },
                });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                toast.error("contract status")
                // window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //GET SINGLE CONTRACT STATUS
    getContractStatus: (id) => (dispatch) => {
        dispatch({
            type: GET_CONTRACT_STATUS,
            payload: {
                getContractStatusLoading: true,
            },
        });
        getContractStatus(id).then((res) => {
            dispatch({
                type: GET_CONTRACT_STATUS,
                payload: {
                    getContractStatusLoading: false,
                },
            });

            if (res?.status === 200) {
                dispatch({
                    type: GET_CONTRACT_STATUS_SUCCESS,
                    payload: {
                        currentContractStatus: res?.data?.status,
                    },
                });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //UPDATE CONTRACT STATUS
    updateContractStatus: (data, id, history) => (dispatch) => {
        dispatch({
            type: UPDATE_CONTRACT_STATUS,
            payload: {
                updateContractStatusLoading: true,
            },
        });

        updateContractStatus(data, id).then((res) => {
            dispatch({
                type: UPDATE_CONTRACT_STATUS,
                payload: {
                    updateContractStatusLoading: false,
                },
            });
            if (res?.status === 200) {
                dispatch({
                    type: UPDATE_CONTRACT_STATUS_SUCCESS,
                    payload: {
                        contractStatus: res?.data?.statuses,
                    },
                });
                history.push("/contract-status");
                toast.success(res?.data?.message || "Success", { theme: "colored" });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //DELETE CONTRACT STATUS
    deleteContractStatus: (id) => (dispatch) => {
        dispatch({
            type: DELETE_CONTRACT_STATUS,
            payload: {
                deleteContractStatusLoading: true,
            },
        });
        deleteContractStatus(id).then((res) => {
            dispatch({
                type: DELETE_CONTRACT_STATUS,
                payload: {
                    deleteContractStatusLoading: false,
                },
            });
            if (res?.status === 200) {
                toast.success(res?.data?.message || "Success", { theme: "colored" });
                dispatch({
                    type: DELETE_CONTRACT_STATUS_SUCCESS,
                    payload: {
                        contractStatus: res?.data?.statuses,
                    },
                });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },



    //ADD CONTRACT LOSS
    addContractLostReason: (data) => (dispatch) => {
        dispatch({
            type: ADD_CONTRACT_LOST_REASON,
            payload: {
                addContractLostReasonLoading: true,
            },
        });

        addContractLostReason(data).then((res) => {
            dispatch({
                type: ADD_CONTRACT_LOST_REASON,
                payload: {
                    addContractLostReasonLoading: false,
                },
            });

            if (res?.status === 200) {
                toast.success(res?.data?.message || "Success", { theme: "colored" });
                dispatch({
                    type: ADD_CONTRACT_LOST_REASON_SUCCESS,
                    payload: {
                        reasons: res?.data?.reasons,
                        addedReason: res?.data?.addedReason
                    },
                });
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //FETCH ALL CONTRACT  REASONS
    getAllContractLostReason: () => (dispatch) => {
        dispatch({
            type: GET_ALL_CONTRACT_LOST_REASON,
            payload: {
                getContractLostReasonsLoading: true,
            },
        });
        getAllContractLostReason().then((res) => {
            dispatch({
                type: GET_ALL_CONTRACT_LOST_REASON,
                payload: {
                    getContractLostReasonsLoading: false,
                },
            });
            if (res?.status === 200) {
                dispatch({
                    type: GET_ALL_CONTRACT_LOST_REASON_SUCCESS,
                    payload: {
                        reasons: res?.data?.reasons,
                    },
                });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //FETCH ALL CONTRACT REASONS LIST
    getAllContractLostReasonList: () => (dispatch) => {
        getAllContractLostReasonList().then((res) => {
            if (res?.status === 200) {
                dispatch({
                    type: GET_ALL_CONTRACT_LOST_REASON_LIST,
                    payload: {
                        reasonsList: res?.data?.reasons,
                    },
                });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                toast.error("contract status")
                // window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //GET SINGLE CONTRACT REASON
    getContractLostReason: (id) => (dispatch) => {
        dispatch({
            type: GET_CONTRACT_LOST_REASON,
            payload: {
                getContractlostReasonLoading: true,
            },
        });
        getContractLostReason(id).then((res) => {
            dispatch({
                type: GET_CONTRACT_LOST_REASON,
                payload: {
                    getContractLostReasonLoading: false,
                },
            });

            if (res?.status === 200) {
                dispatch({
                    type: GET_CONTRACT_LOST_REASON_SUCCESS,
                    payload: {
                        currentReason: res?.data?.reason,
                    },
                });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //UPDATE CONTRACT REASON
    updateContractLostReason: (data, id, history) => (dispatch) => {
        dispatch({
            type: UPDATE_CONTRACT_LOST_REASON,
            payload: {
                updateContractLostReasonLoading: true,
            },
        });

        updateContractLostReason(data, id).then((res) => {
            dispatch({
                type: UPDATE_CONTRACT_LOST_REASON,
                payload: {
                    updateContractLostReasonLoading: false,
                },
            });
            if (res?.status === 200) {
                dispatch({
                    type: UPDATE_CONTRACT_LOST_REASON_SUCCESS,
                    payload: {
                        reasons: res?.data?.reasons,
                    },
                });
                history.push("/contract-loss-reasons");
                toast.success(res?.data?.message || "Success", { theme: "colored" });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //DELETE CONTRACT REASON
    deleteContractLostReason: (id) => (dispatch) => {
        dispatch({
            type: DELETE_CONTRACT_LOST_REASON,
            payload: {
                deleteContractLostReasonLoading: true,
            },
        });
        deleteContractLostReason(id).then((res) => {
            dispatch({
                type: DELETE_CONTRACT_LOST_REASON,
                payload: {
                    deleteContractLostReasonLoading: false,
                },
            });
            if (res?.status === 200) {
                toast.success(res?.data?.message || "Success", { theme: "colored" });
                dispatch({
                    type: DELETE_CONTRACT_LOST_REASON_SUCCESS,
                    payload: {
                        reasons: res?.data?.reasons,
                    },
                });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

    //GET PARAMETERS
    getParameters: (branchUuid) => (dispatch) => {
        dispatch({
            type: GET_CONTRACT_PARAMETERS,
            payload: {
                getParametersLoading: true,
            },
        });
        getContractParameters(branchUuid).then((res) => {
            dispatch({
                type: GET_CONTRACT_PARAMETERS,
                payload: {
                    getParametersLoading: false,
                },
            });
            if (res?.status === 200) {

                dispatch({
                    type: GET_CONTRACT_PARAMETERS_SUCCESS,
                    payload: {
                        parameters: res?.data?.parameters,
                    },
                });

            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            }
        });
    },

    //GET PARAMETERS
    getParametersList: (branchUuid) => (dispatch) => {

        getContractParametersList(branchUuid).then((res) => {

            if (res?.status === 200) {

                dispatch({
                    type: GET_CONTRACT_PARAMETERS_LIST,
                    payload: {
                        parametersList: res?.data?.parameters,
                    },
                });

            } else if (res?.status === 401) {
                window.location = "/session-ended";
            }
            else if (res?.status === 403) {
                toast.error("parameters")
                // window.location = "/forbidden";
            }
        });
    },

    //EDIT PARAMETERS
    editParameters: (data) => (dispatch) => {
        dispatch({
            type: EDIT_CONTRACT_PARAMETERS,
            payload: {
                editParametersLoading: true,
            },
        });
        editContractParameters(data).then((res) => {
            dispatch({
                type: EDIT_CONTRACT_PARAMETERS,
                payload: {
                    editParametersLoading: false,
                },
            });
            if (res?.status === 200) {

                dispatch({
                    type: EDIT_CONTRACT_PARAMETERS_SUCCESS,
                    payload: {
                        parameters: res?.data?.parameters,
                    },
                });

            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            }
        });
    },
};

export default actions;
